import React from 'react';
import { IconButton, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@c2fo/liquidity';
import { AngleDoubleLeftIcon, AngleLeftIcon, AngleRightIcon } from '@c2fo/liquidity/icons';

const PAGE_SIZE_OPTIONS = [
  { value: '10', label: '10 per page' },
  { value: '25', label: '25 per page' },
  { value: '50', label: '50 per page' },
  { value: '100', label: '100 per page' },
];

interface PaginationProps {
  totalSize: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onPageSizeChange: (size: number) => void;
  onFirst: () => void;
  onPrevious: () => void;
  onNext: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  totalSize,
  pageSize,
  currentPage,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  onPageSizeChange,
  onFirst,
  onPrevious,
  onNext,
}) => {
  return (
    <div className="flex items-center justify-between px-2">
      <div className="text-sm text-gray-500">
        {totalSize > 0 ? (
          <>
            Showing {(currentPage - 1) * pageSize + 1} - {Math.min(currentPage * pageSize, totalSize)} of {totalSize}
          </>
        ) : (
          'No results'
        )}
      </div>
      <div className="flex items-center gap-4">
        <Select value={String(pageSize)} onValueChange={(value) => onPageSizeChange(Number(value))}>
          <SelectTrigger className="w-36" size="sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <div className="flex items-center gap-1">
          <IconButton
            icon={AngleDoubleLeftIcon}
            name="First page"
            onClick={onFirst}
            disabled={!hasPreviousPage}
            variant="tertiary"
            size="sm"
          />
          <IconButton
            icon={AngleLeftIcon}
            name="Previous page"
            onClick={onPrevious}
            disabled={!hasPreviousPage}
            variant="tertiary"
            size="sm"
          />
          <span className="text-sm text-gray-700 px-2">
            Page {currentPage} of {totalPages || 1}
          </span>
          <IconButton
            icon={AngleRightIcon}
            name="Next page"
            onClick={onNext}
            disabled={!hasNextPage}
            variant="tertiary"
            size="sm"
          />
        </div>
      </div>
    </div>
  );
};
